import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, Interval } from 'luxon';
import { DateUtility } from '@jms/model';

@Pipe({
  name: 'rangeDate',
  standalone: true
})
export class RangeDatePipe implements PipeTransform {

  transform(value: Date | DateTime | string, from: Date | DateTime | string, to: Date | DateTime | string, timezone = 'utc', message: string = null): string {

    const defaultFrom = new Date(1980, 1, 1, 12, 0, 0);
    const defaultTo = new Date(2050, 12, 31, 0, 0);

    from = DateUtility.getDateTime(from ?? defaultFrom, timezone).startOf('day');
    to = DateUtility.getDateTime(to ?? defaultTo, timezone).endOf('day');

    const intervalTime = Interval.fromDateTimes(from, to);


    if (!value) return null;

    const validRange = intervalTime.contains(DateUtility.getDateTime(value, timezone));

    message = message ?? `(date specified is outside of the range)`;

    return validRange ? null : message;
  }

}
